import React from 'react';
import PropTypes from 'prop-types';
import TaskForm from '../../steps/task/TaskForm';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import translate from '../../../../commonComponents/translate';
import { JOURNEY_STEP_STATUS } from '../../../../services/utilityFunctions';

function JourneyContentTask({ t, step, onChange, onSkipStep }) {
  return (
    <div className="m-portlet m-portlet-rounded">
      <div className="m-portlet__body">
        {step.status !== JOURNEY_STEP_STATUS.WAITING_APPROVAL ? (
          <TaskForm step={step} onDone={onChange} onSkipStep={onSkipStep} />
        ) : (
          <div className="journey-empty-step">
            <div className="journey-empty-step-text">
              {t('journey_awaitingApproval')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

JourneyContentTask.propTypes = {
  t: PropTypes.func.isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
  onChange: PropTypes.func.isRequired,
  onSkipStep: PropTypes.func,
};

JourneyContentTask.defaultProps = {
  onSkipStep: null,
};

export default translate(JourneyContentTask);
